import moment from 'moment';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Row } from 'reactstrap';
import { ControlTypeEnum, IAction, IColumnDef, IControl, IGetDynListParams, IServiceMessage, ITable, IUploadPath, IViewContext, IViewContextParams } from '../abstraction';
import { KPanel } from '../components/';
import { KControlAttachment, KControlCheckbox, KControlImage, KControlInput, KControlJauge, KControlLabel, KControlProgress, KControlRTF, KControlSelect, KControlTableSwitch } from '../components/Controls';
import { AppLabels } from '../core/AppLabels';
import { Utils } from '../core/utils';
import { dispatcher, securitySvc } from '../Karma';
import { ActionModel, ColumnModel, ControlModel, InternalTypeEnum, TableModel } from '../models/index';
import { PanelModel } from '../models/PanelModel';
import { GenView } from './GenView';

interface IProps {
	fnct: string;
	refreshToken: number;
}

interface IState {
	codecontext: string;
	loading: boolean;
	Controls: ControlModel[];
	Actions: ActionModel[];
	tables: TableModel[];
	title: string;
	currentStep: number;
	fonction: string;
	showButtonList: boolean;
	buttonList: ActionModel[];
	panels: PanelModel[];
	redirectUrl: string;
	initialized: boolean;
}

const parseRTF = require('rtf2text');

export class Widget extends React.Component<IProps, IState> {
	static URL: string = "/stdView";

	public constructor(props: any) {
		super(props);

		let showResult: boolean = true;
		this.state = {
			codecontext: "INITIALISATION",
			loading: showResult,
			title: "",
			Controls: [],
			Actions: [],
			tables: [],
			currentStep: 1,
			fonction: this.props.fnct,
			showButtonList: false,
			buttonList: [],
			panels: [],
			redirectUrl: "",
			initialized: false,
		}
		let ctx: IViewContextParams = {
			barCode: "",
			title: "",
			idSession:"",
			idTransaction: "",
			idSite: "",
			context: this.state.codecontext,
			etape: this.state.currentStep,
			fnct: this.props.fnct,
			Controls: [],
			Tables: [],
			Actions: [],
			uploadedFiles: []
		};
		this.refreshContext(ctx);
	}

	//#region React Hacks
	componentWillUnmount = () => {
		window.removeEventListener('resize', this.updateDimensions);
		dispatcher.OnRefreshWidget.reset();
	}
	componentDidMount = () => {
		window.addEventListener('resize', this.updateDimensions);
		dispatcher.OnRefreshWidget.add((fnct_code) => {
			if (fnct_code == this.props.fnct) {
				this.setState({ initialized: false });
				let ctx: IViewContextParams = {
					barCode: "",
					title: "",
					idSession: "",
					idTransaction: "",
					idSite: "",
					context: "INITIALISATION",
					etape: 1,
					fnct: this.props.fnct,
					Controls: [],
					Tables: [],
					Actions: [],
					uploadedFiles: []
				};
				this.refreshContext(ctx);
            }
        })
	}
	updateDimensions = () => {
		this.forceUpdate();
    }
	//#endregion

	//#region Métier et autres méthodes diverses
	// Déclenche le chargement d'un nouveau contexte en fonction de l'état de l'écran actuel
	refreshContext = (ctx: IViewContextParams) => {
		dispatcher.getViewContext(ctx)
			.then((e) => {
				this.onViewContextReceived(e);
			})
			.catch((err) => {
				this.onViewContextReceivedError(err);
			});
	}
	// Balaye l'écran et construit le contexte à envoyer au serveur
	buildViewContextParams(): IViewContextParams {
		let controls: IControl[] = [];
		let tables: ITable[] = [];
		let actions: IAction[] = [];
		let uploads: IUploadPath[] = [];

		this.state.Controls.map((x, i) => {
			if (x.AttachmentDest) {
				let path = securitySvc.currentUser.uploadPaths.filter(p => p.key == x.AttachmentDest)[0];
				if (path) {
					uploads.push({
						key: x.Value,				// Nom du fichier
						value: path.value,			// Destination
					})
				}
			}

			controls.push({
				Code: x.Key,
				Type: x.ControlType,
				Description: x.Description,
				Id: x.Id,
				Label: "",
				NoLabel: x.NoLabel,
				Value: (x.ToUpperCase && x.ToUpperCase) ? x.Value.toUpperCase() : x.Value,
				Complement1: x.Complement1,
				Complement2: x.Complement2,
				Complement3: x.Complement3,
				Visible: x.Visible,
				Disable: x.Disable,
				TypeLenght: x.TypeLenght,
				DataType: x.DataType,
				Popup: x.Popup,
				Content: x.Content,
			})
		});

		this.state.tables.map((x, i) => {

			let tabl: ITable = {
				Type: ControlTypeEnum.table,
				Rows: x.Rows,
				Code: x.Key,
				Id: x.Id,
				ColDefs: [],
				Description: "",
				Actions: [],
				SelectedRow: null,
				Visible: x.Visible,
				Disable: x.Disable,
				NewRows: "",
			};

			x.colsDef.filter(c => c.IsMerged == false).map((column, i) => {
				tabl.ColDefs.push({
					SearchFieldName: column.ColSearchField,
					Id: column.Id,
					Code: column.Key,
					FieldName: column.FieldName,
					Title: column.Title,
					Type: column.Type,
					Visible: column.Visible,
					Disable: column.Disable,
					ColType: column.DataType,
					Class: column.Class,
					IsMerged: false,
				})
			});

			if (x.selectedRow) {
				tabl.SelectedRow = x.selectedRow;
			}

			x.actions.map((t, i) => {
				tabl.Actions.push(t.adapt())
			});

			tables.push(tabl)
		});

		this.state.Actions.map((x, i) => {

			actions.push({
				Type: ControlTypeEnum.action,
				Action: x.Action,
				Code: x.Key,
				Text: x.Text,
				WebService: x.WebService,
				Context: x.Context,
				Id: x.Id,
				Target: x.Target,
				Visible: x.Visible,
				Disable: x.Disable,
			})
		});

		return {
			barCode: "",
			idTransaction: "",
			idSession: "",
			idSite: "",
			context: "",
			title: this.state.title,
			Controls: controls,
			etape: this.state.currentStep,
			fnct: this.state.fonction,
			Tables: tables,
			Actions: actions,
			uploadedFiles: uploads,
		}
	}

	// Méthode appelée par la liste de sélection (callback) pour obtenir la liste des champs de la page avant appel au WS
	getDynamicListParams(): IGetDynListParams {
		let context = this.buildViewContextParams();
		let state: IGetDynListParams = {
			filters: [],
			flxCod: this.state.fonction,
			kmaZone: "",	// filled by select component 
			site: "",	// filled by dispatcher
		}
		context.Controls.map(x => {
			state.filters.push({ Key: x.Code, Value: x.Value, Id: x.Id });
		});
		context.Tables.map(x => {
			x.ColDefs.map(col => {
				state.filters.push({ Key: col.Code, Value: ((x.SelectedRow != null) && (x.SelectedRow != undefined)) ? x.SelectedRow[col.Code] : "", Id: x.Id });
			});
		});
		state.filters = state.filters.sort((a, b) => (a.Id > b.Id) ? 1 : -1);
		return state;
	}
	//#endregion

	//#region Evènements Locaux
	// Un demande de chargement de contexte a échoué
	// On trace l'intégralité des messages reçus sur la console et on affiche le 1er en message box
	onViewContextReceivedError = (e: IServiceMessage[]) => {
		console.log("!! widgetView - onViewContextReceivedError ");
	}
	// Réception nouveau context
	onViewContextReceived = (viewContext: IViewContext) => {
		if (this.state.initialized == true) {
			dispatcher.getLastViewContext().IsWidget = true;
			this.setState({redirectUrl: GenView.URL + "/PRH2"});
			return;
		}
		else {
			this.setState({ initialized: true })
		};

		try {
			// Retour d'un appel à une IMPRESSION
			// On indique juste que l'impression a été prise en compte, et c'est tout / pas de rendu
			let ctrls: ControlModel[] = [];
			let actions: ActionModel[] = [];
			// Efface l'écran
			this.setState({
				Controls: [],
				Actions: [],
				loading: false,
				title: viewContext.Description,
			});
			// Balaye les contrôles
			viewContext.Controls.map((x) => {
				let control = ControlModel.create(x)
				// Si le contrôle est de type image (et accessoirement visible)
				if ((control.ControlType == ControlTypeEnum.image) && (control.Visible)) {
					// Value contient l'indice de l'image
					let indice = Number(control.Value) - 1;
					// Les images étant stockées dans un tableau dédié, on transfère le contenu sur notre controle
					if (viewContext.Images[indice]) {
						control.Content = viewContext.Images[indice].data;
						control.ContentType = viewContext.Images[indice].mimetype;
					}
					else {
						// Si undefined, on cache l'image
						control.Visible = false;
					}
				}
				// La même chose mais avec les RTF siouplé
				if ((control.ControlType == ControlTypeEnum.viewerRTF) && (control.Visible)) {
					// RTFs stockés dans tableau Texts
					let rtf = viewContext.Texts[Number(control.Value) - 1];
					// ON parse le contenu
					parseRTF.string(rtf, async (err, text) => {
						control.Content = text;
						control.ContentType = "text";

						// L'appel a cette méthode état asynchrone, on effectue une mise à jour de l'état une fois terminé
						this.setState({ Controls: ctrls, });
					}
					);
				}
				// On affecte le contrôle à l'indice spécifié par control.key, cela permettra d'y accéder par la commande ctrls['clé'] (utilie pour les attributs)
				ctrls[control.Key] = control;
				ctrls.push(control);
			});

			// Balaye les actions et crée les boutons correspondants
			viewContext.Actions.map((a) => {
				let action = ActionModel.create(a);
				actions[action.Key] = action;
				actions.push(action);
			})

			this.setState({ tables: [] });
			//#region Lecture des attributs
			let attributes: object = null;
			try {
				attributes = JSON.parse(viewContext.Attributes);
			}
			catch (err) {
				dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContent, 3);
				console.log("*** Error in Attributes JSON. Check message below for further informations : ");
				console.log(err);
			}
			//#endregion 
			//#region Traitement des attributs de zones
			// => IMPORTANT : Il faut récupérer les attributs de zones AVANT la construction des tableaux et ce, pour pouvoir récupérer les attributs et les affecter aux tableaux lors de la création
			if (attributes) {
				if (attributes["Attributes"]["Flow"]) {
					let ctrl: object[] = attributes["Attributes"]["Flow"][0];
					for (let c in ctrl) {                                       // { [X1:{], X2:{}]} Ici on parse X1, X2 etc
						for (let target in ctrl[c]) {
							viewContext[target] = ctrl[c][target];
						}
					}
				}
				// Application des attributs sur les zones
				try {
					// Converti le flux JSON en objet
					let ctrl: object[] = attributes["Attributes"]["Controls"];

					// Parse chaque objet, puis chaque propriété pour la transférer sur le control déjà en place
					for (let c in ctrl) {                                       // { [X1:{], X2:{}]} Ici on parse X1, X2 etc
						for (let target in ctrl[c]) {                           // ici on récupère le littéral X1 pour pouvoir cibler al destination
							for (let prop in ctrl[c][target]) {                 // On parcours maintenant chaque propriétés
								try {
									if (ctrls[target])
										ctrls[target][prop] = ctrl[c][target][prop];    // Et on met à jour 
								}
								catch (err) {
									dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContentFullZone.replace('%%0%%', prop).replace('%%1%%', target), 3);
									console.log("*** Error in Attributes JSON. Check message below for further informations : ");
									console.log(err);
								}
							}
						}
					}
				}
				catch (err) {
					dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContent, 3);
					console.log("Error in Attributes JSON. Check message below for further informations : ");
					console.log(err);
				}

			}
			//#endregion Traitement des attributs de zones

			//#region Création des objets tableaux
			viewContext.TableDefs.map((x) => {
				let table = TableModel.create(x);
				// Applique les attributs des zones de tableaux sur les colonnes correspondantes
				try {
					let ctrl: object[] = attributes["Attributes"]["Controls"];
					for (let ctrlIndex in ctrl) {
						for (let target in ctrl[ctrlIndex]) {
							for (let prop in ctrl[ctrlIndex][target]) {
								let column = table.colsDef.filter(c => c.FieldName == target)[0];
								if (column)
									column[prop] = ctrl[ctrlIndex][target][prop];
							}
						}
					}
				}
				catch (err) {
					dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContent, 3);
					console.log("Error in Attributes JSON (columns). Check message below for further informations : ");
					console.log(err);
				}
				table.colsDef.filter(c => c.ColMergeTargets).map((col, index) => {
					let colId: string = col.FieldName + "_" + col.ColMergeTargets.replace(";", "_");
					let title: string = AppLabels[col.ColMergeTitle];
					if (title == undefined) title = col.ColMergeTitle;
					let c: IColumnDef = {
						Class: col.ColMergeCSS,
						Code: colId,
						ColType: col.DataType,
						Disable: col.Disable,
						Title: title,
						FieldName: colId,
						SearchFieldName: col.ColSearchField,
						Id: 50000 + col.Id,
						Type: ControlTypeEnum.table,
						Visible: col.Visible,
						IsMerged: true,
					}
					// ON place la colonne à la place de la colonne source
					table.colsDef.splice(index, 0, ColumnModel.create(c));
				});
				var ctrlTab = ctrls.filter(t => t.Id == x.Id)[0];
				if (ctrlTab != undefined) {
					table.bsSize = ctrlTab.bsSize;
					table.DefaultSort = ctrlTab.DefaultSort;
					table.BgRedCond = ctrlTab.BgRedCond;
					table.BgOrangeCond = ctrlTab.BgOrangeCond;
					table.BgYellowCond = ctrlTab.BgYellowCond;
					table.BgGreenCond = ctrlTab.BgGreenCond;
					table.TabRowDblClick = ctrlTab.TabRowDblClick;
					table.TabAction1 = ctrlTab.TabAction1;
					table.TabAction2 = ctrlTab.TabAction2;
					table.Class = ctrlTab.Class;
					table.TreeViewKeyPath = ctrlTab.TreeViewKeyPath;
					table.TreeViewParentKeyPath = ctrlTab.TreeViewParentKeyPath;
					table.TreeViewIsExpandedPath = ctrlTab.TreeViewIsExpandedPath;
					table.TreeViewIconPath = ctrlTab.TreeViewIconPath;
					table.TreeViewLevelPath = ctrlTab.TreeViewLevelPath;
					table.NormBarcod = ctrlTab.NormBarcod;
					table.BarCodCond = ctrlTab.BarCodCond;
					table.ValidCond = ctrlTab.ValidCond;
					table.TabAutoSelectSingleRow = ctrlTab.TabAutoSelectSingleRow;
					table.TabAutoSelectAction = ctrlTab.TabAutoSelectAction;
					table.ShowAsGraph = ctrlTab.ShowAsGraph;
					table.GraphType = ctrlTab.GraphType;
					table.GraphSeries = ctrlTab.GraphSeries;
					table.GraphXPath = ctrlTab.GraphXPath;
					table.GraphSeriesColor = ctrlTab.GraphSeriesColor;
				}
				let current = this.state.tables.filter(t => t.Key == x.Code)[0];
				if (current != undefined) {
					table.actions = current.actions;
				}
				this.state.tables.push(table);
			});

			//#endregion Création des objets tableaux

			//#region Application des attributs sur les boutons
			// on le fait après la création des tableaux car ceux ci contiennent des actions

			if (attributes) {
				try {
					// Converti le flux JSON en objet
					let act: object[] = attributes["Attributes"]["Actions"];

					// Parse chaque objet, puis chaque propriété pour la transférer sur le control déjà en place
					for (let c in act) {                                       // { [X1:{], X2:{}]} Ici on parse X1, X2 etc
						for (let target in act[c]) {                           // ici on récupère le littéral X1 pour pouvoir cibler al destination
							for (let prop in act[c][target]) {                 // On parcours maintenant chaque propriétés
								try {
									actions[target][prop] = act[c][target][prop];    // Et on met à jour 
								}
								catch (err) {
									this.state.tables.map((tt) => {
										let ac = tt.actions.filter(i => i.Key == target)[0];
										if (ac != undefined) {
											try {
												ac[prop] = act[c][target][prop];
											}
											catch (err) {
												dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContentFullZone.replace('%%0%%', prop).replace('%%1%%', target), 3);
												console.log("Error in Attributes JSON. Check message below for further informations : ");
												console.log(err);
											}
										}
									})
								}
							}
						}
					}
				}
				catch (err) {
					console.log(err)
				}
			}
			//#endregion Application des attributs sur les boutons

			// On affecte un id panel par défaut pour les éléments qui z'en n'ont pas
			ctrls.map((x) => {
				if (x.IdPanel == "") x.IdPanel = "__defautPanel";

				if (x.DataType == InternalTypeEnum.Date) x.InputType = "date";
				if (x.DataType == InternalTypeEnum.Datetime) x.InputType = "time";
				if ((x.TypeLenght) && (x.MaxLength == undefined)) x.MaxLength = x.TypeLenght;

			});
			if (viewContext.MultiAnswers.length > 0) {
				let t = this.state.tables.filter(t => t.NormBarcod)[0];
				if (t != undefined) {
					t.newRows = viewContext.MultiAnswers[0];
				}
			}
			let panels: PanelModel[] = [];
			ctrls.filter(c => c.Visible == true).map(c => {
				let pan = panels.filter(p => p.id == c.IdPanel)[0];
				if (pan == undefined)
					panels.push({ id: c.IdPanel, collapsed: c.DivCollapsed ? true : false })
				else {
					if (c.DivCollapsed == true) pan.collapsed = true;
				}
			});
			this.setState({
				Controls: ctrls,
				Actions: actions,
				tables: this.state.tables,
				currentStep: viewContext.Step,
				fonction: viewContext.FunctionName,
				panels: panels
			});
		}
		catch (err) {
			console.error(err);
		}
	}

	// Clic sur l'un des boutons action du tableau
	onActionClicked = async (table: TableModel, action: ActionModel, row: any) => {
		// Le bouton demande confirmation avant de poursuivre
		// On affiche donc la fenêtre via le dispatcher

		// On regarde si le text correspond à label traduit, si c'est le cas on prend le texte correspondant, sinon on affiche simplement le contenu de YesNo
		let text = AppLabels[action.YesNo];
		if (text == undefined) text = action.YesNo

		if (action.YesNo) {
			if (! await dispatcher.ConfirmBox(AppLabels.confirmTitle, text, AppLabels.yes, AppLabels.no))
				return;
		}

		let ctx: IViewContextParams = this.buildViewContextParams();
		ctx.context = action.Context;
		this.refreshContext(ctx);
	}

	//#endregion

	//#region Rendu

	renderView = (popupCode: string = "") => {
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
		let panels: PanelModel[] = [];
		let ctrls: ControlModel[] = [];
		// Si pas de code popup, on prend tous les contrôles visibles
		ctrls = this.state.Controls.filter((a) => a.Visible == true);
		// Seuls les panels contenant au moins 1 élément sont affichés
		this.state.panels.map(pan => {
			let c = ctrls.filter((a) => a.IdPanel == pan.id);
			if (c.length > 0) panels.push(pan);
		});
		return (
			<div >{
				panels.map((pan, panId) => {
					return (
						<KPanel Id={panId} isExpanded={pan.collapsed == false} Title={AppLabels[pan.id] ? AppLabels[pan.id] : ""} key={panId} >
							<Row>{
								ctrls
									.filter((a) => a.IdPanel == pan.id)
									.sort((a, b) => { return (Number(a.Id) > Number(b.Id)) ? 1 : -1 })
									.map((x, i) => {
										switch (Number(x.ControlType)) {
											case ControlTypeEnum.label:
												return <KControlLabel key={i} Control={x}></KControlLabel>

											case ControlTypeEnum.progress:
												return <KControlProgress key={i} Control={x}></KControlProgress>

											case ControlTypeEnum.jauge:
												return <KControlJauge key={i} Control={x}></KControlJauge>

											case ControlTypeEnum.document:
												return <KControlAttachment dispatcher={dispatcher} key={i} Control={x}></KControlAttachment>

											case ControlTypeEnum.input:
												return <KControlInput imageProvider={dispatcher} msgBoxProvider={dispatcher} virtualKeyboard={dispatcher} key={i} Control={x} ></KControlInput>

											case ControlTypeEnum.select:
											case ControlTypeEnum.selectControled:
											case ControlTypeEnum.selectFree:
												return <KControlSelect dispatcher={dispatcher} key={i} control={x} ></KControlSelect>

											case ControlTypeEnum.selectDynamic:
												return <KControlSelect
													dispatcher={dispatcher}
													key={i}
													control={x}
													getViewstate={() => { return this.getDynamicListParams(); }} ></KControlSelect>

											case ControlTypeEnum.checkbox:
												return <KControlCheckbox imageProvider={dispatcher} key={i} control={x}></KControlCheckbox>

											case ControlTypeEnum.table:
												let tab = this.state.tables.filter((t) => t.Key == x.Key)[0];
												if (tab != undefined) {
													return <KControlTableSwitch dispatcher={dispatcher} imageProvider={dispatcher} onActionClicked={this.onActionClicked} key={i} table={tab} hideActionBar={true}></KControlTableSwitch >
												}
												return null;

											case ControlTypeEnum.image:
												return <KControlImage key={i}
													imgProvider={dispatcher}
													bsSize={Utils.getColSizeClasses(x)}
													Class={x.Class}
													Content={x.Content}
													Description={x.Description}
													InlineStyle={x.InlineStyle}
													ShowHeader={true}
													Key={x.Key}
													ShowMoreIcon={x.ShowMoreIcon}
													Visible={x.Visible}
													ContentType={x.ContentType}
													ShowMoreOnLoad={x.ShowMoreOnLoad}
												>
												</KControlImage>

											case ControlTypeEnum.viewerRTF:
												return <KControlRTF
													imageProvider={dispatcher}
													key={i} bsSize={Utils.getColSizeClasses(x)}
													ShowMoreOnLoad={x.ShowMoreOnLoad}
													control={x}
												/>												
										}
									})
							}</Row>
						</KPanel>)
				}
				)
			}</div>
		);
	}

	render() {
		if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>

		if (this.state.loading) return null;
		let view = this.renderView();
		return (
			<React.Fragment>
				{view}
			</React.Fragment>
		);
	}

	//#endregion
}
